module.exports = __webpack_public_path__ + "img/9788958282372.fc0ecf3b.jpg";